window.onload = () => {
    const store = 'lodoro.myshopify.com';
    
    setTimeout(() => {
	  const changeProvince = (province) => {
        document.getElementById('shipping_rates').style.display = 'none';
        
        document.getElementById('checkout__city').innerHTML = '<option selected disabled>Cargando...</option>';

        fetch(`https://enviospersonalizados.lobocreaciones.dev/api/coverages/cities/enabled?store=${store}`)
            .then(response => response.json())
            .then((data) => {
              
                const cities = data.comunas.filter((region) => region.region === province);

                let options = cities.reduce((aux, city) => 
                  aux + '<option value=\"' + city.nombre + '\">' + city.nombre + '</option>', 
                  '<option selected disabled>Selecciona tu Comuna</option>');

                document.getElementById('checkout__city').innerHTML = options;
              
            })
            .catch((error) => {
              
                console.log(error.message);
              
            });
      };
    
      const changeCity = (city) => {
        let province = document.getElementById('checkout__province').value;
        
        // Calcular costo del envío
        fetch('/cart.js')
            .then(response => response.json())
            .then((cart) => {
              if (cart.item_count > 0) {
                
                document.getElementById('shipping_rates').style.display = 'block';

                let grams = 0, 
                    total = 0;

                cart.items.forEach((item) => {
                  grams += (item.grams * item.quantity)
                  total += (item.final_price * item.quantity)
                });

                const cartOptions = {
                  method: 'POST',
                  headers: {
                    'x-shopify-shop-domain': store,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    rate: {
                      origin: {
                        country: 'CL'
                      },
                      destination: {
                        province: province,
                        city: city
                      },
                      items: [
                        {
                          quantity: 1,
                          grams: grams,
                          price: total
                        }
                      ],
                      currency: 'CLP',
                      locale: 'es'
                    }
                  })
                };

                document.getElementById('shipping_loading').style.display = 'block';
                document.getElementById('shipping_value').style.display = 'none';

                fetch('https://enviospersonalizados.lobocreaciones.dev/api/couriers/rates', cartOptions)
                    .then(response => response.json())
                    .then((response) => {
                        if (response.rates[0]) {
                          
                          let rates = response.rates;

                          rates.sort((rate1, rate2) => {
                              if (rate1.total_price < rate2.total_price)
                                  return -1

                              if (rate1.total_price > rate2.total_price)
                                  return 1

                              return 0
                          });

                          let rate_price = Number(response.rates[0].total_price + 'e-2')

                          document.getElementById('shipping_loading').style.display = 'none';
                          document.getElementById('shipping_value').style.display = 'block';
                          document.getElementById('rate_price').innerHTML = '$' + String(rate_price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
                          
                        } else {
                          
                          document.getElementById('shipping_loading').style.display = 'none';
                          document.getElementById('shipping_value').style.display = 'block';
                          document.getElementById('rate_price').innerHTML = 'Esta comuna no posee cobertura.';
                          
                        }
                    })
                    .catch((error) => {
          
                      console.log(error.message);
                      
                    });
                
              }
            });

        let cartForm = document.getElementById('cart__form');
        cartForm.action = `cart?step=contact_information&checkout[shipping_address][country]=CL&checkout[shipping_address][province]=${province}&checkout[shipping_address][city]=${city}`;

        const $shippingAddressCountry = document.querySelector('input[name="[shipping_address][country]"]'),
             $shippingAddressProvince = document.querySelector('input[name="[shipping_address][province]"]'),
             $shippingAddressCity = document.querySelector('input[name="[shipping_address][city]"]');

        if ($shippingAddressCountry) $shippingAddressCountry.remove();
        if ($shippingAddressProvince) $shippingAddressProvince.remove();
        if ($shippingAddressCity) $shippingAddressCity.remove();

        const shippingDetails = `<input type="hidden" name="[shipping_address][country]" value="CL">
                                <input type="hidden" name="[shipping_address][province]" value="${province}">
                                <input type="hidden" name="[shipping_address][city]" value="${city}">`;

        cartForm.insertAdjacentHTML('beforeend', shippingDetails);
      };

      document.getElementById('checkout__province').addEventListener('change', (e) => { changeProvince(e.target.value) });
      document.getElementById('checkout__city').addEventListener('change', (e) => { changeCity(e.target.value) });
    }, 1000);
    
    setTimeout(() => {
      if (document.getElementsByName("checkout")) {

        [...document.getElementsByName("checkout")].map((button) => {
    
          button.addEventListener('click', (e) => {

            document.getElementById('cart__form').submit();
            
          });
        
        });
        
      };

      
	  document.getElementById('checkout__province').innerHTML = '<option selected disabled>Cargando...</option>';
      
      fetch(`https://enviospersonalizados.lobocreaciones.dev/api/coverages/provinces/enabled?store=${store}`)
        .then(response => response.json())
        .then((data) => {
          if (data.regiones.length > 0) {
            
            let options = data.regiones.reduce((aux, province) => 
              aux + '<option value=\"' + province.codigo + '\">' + province.nombre + '</option>', 
              '<option selected disabled>Selecciona tu Región</option>');

            document.getElementById('checkout__province').innerHTML = options;
            
          } else {
            
            document.getElementById('checkout__province').innerHTML = '<option selected disabled>Sin Cobertura</option>';
            
          }
          
        })
        .catch((error) => {
          
          console.log(error.message);
          
        });
    }, 100);
};